import { Pipe, PipeTransform, inject } from '@angular/core';
import { BN_API_CONFIG } from '../tokens/api-config.token';

@Pipe({
  name: 'imageUrl',
  standalone: true,
})
export class ImageUrlPipe implements PipeTransform {
  private config = inject(BN_API_CONFIG);

  transform(value: string | undefined | null): string {
    if (!value) {
      return 'assets/default-playlist.webp';
    }

    if (value.startsWith('http')) {
      return value;
    }

    const validApiUrl = this.config.apiUrl.replace(/^https?:\/\/[^/]+/, '');

    if (value.startsWith('/')) {
      return `${validApiUrl}/public${value}`;
    }

    return value;
  }
}
